import { client, gql } from 'data-provider';
import { FeatureFlags } from 'utilities/menu-visibility';

export const getFeatureFlags = async () => {
  const query = gql`
    query {
      featureFlags
    }
  `;
  const data = await client.request(query);
  return (data.featureFlags ?? {}) as FeatureFlags;
};
